import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from "../views/dashboard/home/index"

import CategoriesIndex from "../views/dashboard/categories/index"
import ProductsIndex from "../views/dashboard/products/index"
import OrdersIndex from "../views/dashboard/orders/index"
import OrdersEdit from "../views/dashboard/orders/edit"

import OffersIndex from "../views/dashboard/offers/index"
import OffersEdit from "../views/dashboard/offers/edit"

import RecipesFinishingsIndex from "../views/dashboard/recipes/finishings/index"
import RecipesFinishingsEdit from "../views/dashboard/recipes/finishings/edit"
import RecipesWetendIndex from "../views/dashboard/recipes/wetend/index"
import RecipesWetendEdit from "../views/dashboard/recipes/wetend/edit"

import ProformasIndex from "../views/dashboard/proformas/index"
import ProformasEdit from "../views/dashboard/proformas/edit"

import AdminsIndex from "../views/dashboard/admins/index"

import UsersIndex from "../views/dashboard/users/index"
import UsersEdit from "../views/dashboard/users/edit"


import LoginIndex from "../views/login/index"

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'home',
        component: Home
	},
	
    {
        path: '/categories',
        name: 'CategoriesIndex',
        component: CategoriesIndex
    },
    {
        path: '/products',
        name: 'ProductsIndex',
        component: ProductsIndex
    },
    {
        path: '/orders/:order_type',
        name: 'OrdersIndex',
        component: OrdersIndex
    },
    {
        path: '/orders/:order_type/edit',
        name: 'OrdersEdit',
        component: OrdersEdit
    },
    {
        path: '/offers/:offer_type',
        name: 'OffersIndex',
        component: OffersIndex
    },
    {
        path: '/offers/:offer_type/edit',
        name: 'OffersEdit',
        component: OffersEdit
    },
    {
        path: '/recipes/finishings',
        name: 'RecipesFinishingsIndex',
        component: RecipesFinishingsIndex
    },
    {
        path: '/recipes/finishings/edit',
        name: 'RecipesFinishingsEdit',
        component: RecipesFinishingsEdit
    },
    {
        path: '/recipes/wetend',
        name: 'RecipesWetendIndex',
        component: RecipesWetendIndex
	},
    {
        path: '/recipes/wetend/edit',
        name: 'RecipesWetendEdit',
        component: RecipesWetendEdit
	},

    {
        path: '/proformas/:proforma_type',
        name: 'ProformasIndex',
		component: ProformasIndex, 
	},
    {
        path: '/proformas/:proforma_type/edit',
        name: 'ProformasEdit',
		component: ProformasEdit, 
	},
	
    {
        path: '/admins',
        name: 'AdminsIndex',
        component: AdminsIndex
    },
    {
        path: '/users',
        name: 'UsersIndex',
        component: UsersIndex
    },
    {
        path: '/users/edit',
        name: 'UsersEdit',
        component: UsersEdit
	},
	

    {
        path: '/login',
        name: 'LoginIndex',
        component: LoginIndex
	},
	

    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import( /* webpackChunkName: "about" */ '../views/About.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router